import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface CreateOrderUserResponse {
  message: string;
  userId: string;
  rolePermissionsDetailId: number;
  memberProductId: number;
  orderNo: string;
};

// 请求接口
export interface CreateOrderUserRequest {
  agentId: string;
  userName?: string;
  email: string;
  goodsId: string;
  description?: string;
  orderAttachment?: string;
  orderAttachmentName?: string;
  orderAttachmentType?: string;
}


export class CreateOrderUserData {
  @IsString("userId must be a string")
  userId: string;
}

const transformAndValidateAgent = (
  response: CreateOrderUserResponse
): CreateOrderUserData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, CreateOrderUserData);
  } catch (error) {
    console.error("Create Order User data validation failed:", error.message);  
    throw error;
  }
};

/** 添加订单用户 */
export const createOrderUser = async ({
  agentId,
  userName,
  email,
  goodsId,
  description,
  orderAttachment,
  orderAttachmentName,
  orderAttachmentType,
}: CreateOrderUserRequest): Promise<CreateOrderUserData> => {
    const response = await api.post<CreateOrderUserResponse>('/agent-v2/create-order-user', {
    agent_id: agentId,
    user_name: userName,
    email: email,
    description: description,
    order_attachment: orderAttachment,
    order_attachment_name: orderAttachmentName,
    order_attachment_type: orderAttachmentType,
    goods_id: goodsId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
